/* eslint-disable */
import axios from "axios"

export async function getReactionsAPI ({ type, reactionable_type, reactionable_id, page = 1 }) {
	let responseData = null
	await axios
		.get('reactions', {
			params: {
				type,
				reactionable_type,
				reactionable_id,
				page
			}
		})
		.then(response => {
			console.log("GET REACTIONS SUCCESS", response);
			responseData = {
				data: response.data,
				success: true
			}
		})
		.catch(error => {
			console.log("GET REACTIONS ERROR", error);
		})
	return responseData
}

export async function setReactionAPI ({ type, reactionable_type, reactionable_id }) {
	let responseData = null
	await axios
		.post('reactions', {
			type,
			reactionable_type,
			reactionable_id
		})
		.then(response => {
			console.log("SET REACTION SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true
			}
		})
		.catch(error => {
			console.log("SET REACTIONS ERROR", error);
		})
	return responseData
}

export async function updateReactionAPI ({ type, id }) {
	let responseData = null
	await axios
		.patch('reactions/' + id, {
			type
		})
		.then(response => {
			console.log("UPDATE REACTION SUCCESS", response);
			responseData = {
				data: response.data.data,
				success: true
			}
		})
		.catch(error => {
			console.log("UPDATE REACTIONS ERROR", error);
		})
	return responseData
}

export async function removeReactionAPI ({ id }) {
	let responseData = false
	await axios
		.delete('reactions/' + id)
		.then(response => {
			console.log("UPDATE REACTION SUCCESS", response);
			responseData = true
		})
		.catch(error => {
			console.log("UPDATE REACTIONS ERROR", error);
		})
	return responseData
}
